
import * as React from 'react'
import { Image, Text, View, TouchableOpacity, Dimensions, ScrollView } from 'react-native'
import images from '../../assets/images'
import { useTheme } from '@react-navigation/native'
import moment from 'moment'
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { TabView, SceneMap } from 'react-native-tab-view'
import ProcessFill from './ProcessFill'
import ProcessDay from './ProcessDay'
import ProcessMonth from './ProcessMonth'

const initialLayout = { width: Dimensions.get('window').width };

export default React.memo(function TabProcess({ navigation, route }) {
    const { colors } = useTheme()
    const insets = useSafeAreaInsets()
    const [filters, setFilter] = React.useState({})
    const [month_string, setMonthString] = React.useState(moment().format('MM/YYYY'))
    const [day_string1, setDayString1] = React.useState(moment().format('DD/MM/YYYY'))
    const [day_string2, setDayString2] = React.useState(moment().format('DD/MM/YYYY'))
    const [index, setIndex] = React.useState(0);
    const [routes] = React.useState([
        { key: 'first', title: 'Chỉ số tháng' },
        { key: 'second', title: 'Chỉ số ngày' },
        { key: 'third', title: 'HSLĐ ngày' },
    ]);
    const renderScene = ({ route }) => {
        switch (route.key) {
            case 'first':
                return <ProcessMonth month_string={month_string} />
            case 'second':
                return <ProcessDay day_string={day_string1} />
            case 'third':
                return <ProcessFill day_string={day_string2} filters={filters} />
        }
    }

    const renderDatePicker = (index) => {
        switch (index) {
            case 0:
                return <TouchableOpacity onPress={() => navigation.navigate('ModalCalendar', { tab_screen: 'process', month_string: month_string })}>
                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{month_string}</Text>
                </TouchableOpacity>
            case 1:
                return <TouchableOpacity onPress={() => navigation.navigate('ModalCalendar', { tab_screen: 'process', day_string: day_string1 })}>
                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{day_string1}</Text>
                </TouchableOpacity>
            case 2:
                return <TouchableOpacity onPress={() => navigation.navigate('ModalCalendar', { tab_screen: 'process', day_string: day_string2 })}>
                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{day_string2}</Text>
                </TouchableOpacity>
            default:
                return null
        }
    }

    React.useEffect(() => {
        if (route.params?.day) {
            switch (index) {
                case 0: setMonthString(route.params?.day)
                    break
                case 1: setDayString1(moment(route.params?.day, 'YYYY-MM-DD').format('DD/MM/YYYY'))
                    break
                case 2: setDayString2(moment(route.params?.day, 'YYYY-MM-DD').format('DD/MM/YYYY'))
                    break
            }
        }
    }, [route.params?.day])

    React.useEffect(() => {
        if (route.params?.filters)
            setFilter(route.params?.filters)
    }, [route.params?.filters])

    return (
        <View style={{ flex: 1 }}>
            <View style={{ paddingHorizontal: 16, marginBottom: 3, paddingTop: insets.top ? insets.top : 14, alignItems: 'center', flexDirection: 'row' }}>
                <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', marginLeft: 11, flex: 1, fontSize: 32 }}>Vận hành</Text>
                {renderDatePicker(index)}
            </View>
            <View style={{ flexDirection: 'row', marginLeft: 22 }}>
                {
                    routes.map((item, idx) => {
                        return <TouchableOpacity style={{
                            borderBottomWidth: 1, borderBottomColor: index !== idx ? 'transparent' : colors.text,
                            marginRight: 24, paddingBottom: 6
                        }} onPress={() => setIndex(idx)} key={idx}>
                            <Text style={{ color: colors.text, fontFamily: index !== idx ? 'Nunito_400Regular' : 'Nunito_700Bold' }}>{item.title}</Text>
                        </TouchableOpacity>
                    })
                }
            </View>
            <TabView
                navigationState={{ index, routes }}
                renderScene={renderScene}
                onIndexChange={setIndex}
                initialLayout={initialLayout}
                renderTabBar={() => null}
            />
        </View>
    )
})